/* Keep collection AJAX metadata identical to the server-rendered collection state. */
(function () {
  'use strict';
  var main = document.getElementById('MainContent');
  if (!main) return;
  // Kalles can restore the first collection view only when its history entry has a path.
  function seedInitialHistory() {
    if (!main.querySelector('[data-sh-collection-seo]') ||
        !main.querySelector('[data-ntajax-options]')) return;
    var entry = window.history.state;
    // Preserve other scripts' state and any entry already owned by the theme.
    if (entry !== null && (typeof entry !== 'object' || Array.isArray(entry))) return;
    if (entry && 'path' in entry) return;
    var initial = Object.assign({}, entry || {}, {
      path: window.location.pathname + window.location.search + window.location.hash,
      updateFilter: true
    });
    try {
      window.history.replaceState(initial, '', window.location.href);
    } catch (error) {
      // Metadata synchronization must still work if history state cannot be written.
    }
  }
  seedInitialHistory();
  var previous = '';
  function sync() {
    var state = main.querySelector('[data-sh-collection-seo]');
    if (!state) return;
    var canonical = state.getAttribute('data-sh-canonical');
    var noindex = state.getAttribute('data-sh-noindex') === 'true';
    var title = state.getAttribute('data-sh-title');
    var signature = JSON.stringify([canonical, noindex, title]);
    if (!canonical || signature === previous) return;
    var link = document.head.querySelector('link[rel="canonical"]');
    if (!link) return;
    link.href = canonical;
    var robots = document.head.querySelector('meta[data-sh-collection-robots]');
    if (noindex && !robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      robots.setAttribute('data-sh-collection-robots', '');
      document.head.appendChild(robots);
    }
    if (noindex) robots.content = 'noindex,follow';
    else if (robots) robots.remove();
    if (title) document.title = title;
    previous = signature;
  }
  sync();
  new MutationObserver(sync).observe(main, { childList: true, subtree: true });
}());
